export default __webpack_public_path__ + "static/media/zodiacToto-Ox.596bba9b.png";